/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PublicationFieldsOneOf { 
    deleted?: boolean;
    deletedOn?: boolean;
    deletedBy?: boolean;
    createdOn?: boolean;
    modifiedOn?: boolean;
    createdBy?: boolean;
    modifiedBy?: boolean;
    id?: boolean;
    name?: boolean;
    description?: boolean;
    coverPhotoUrl?: boolean;
    fileUrl?: boolean;
    externalUrl?: boolean;
    discount?: boolean;
    showInPopup?: boolean;
    publishedOn?: boolean;
    expirationDate?: boolean;
    webPublishedOn?: boolean;
    published?: boolean;
    isPinned?: boolean;
    celebratedUserId?: boolean;
    yearsOfService?: boolean;
    publicationTypeId?: boolean;
}

